// extracted by mini-css-extract-plugin
module.exports = {"Area":"Common_Area__3SgTR","Header":"Common_Header__1cMQN","Content":"Common_Content__Xo2nD"};